import {useState} from 'react';

function AuthForm({mode}) {
  const [message, setMessage] = useState('');
  const isSignup = mode === 'signup';

  function handleSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;
    const password = form.elements.password.value;
    const confirmation = form.elements.confirmPassword?.value;

    if (isSignup && password !== confirmation) {
      setMessage('Those passwords don’t match. Please check and try again.');
      return;
    }

    setMessage(
      isSignup
        ? 'This preview cannot create an account yet. Connect an authentication backend to enable signup.'
        : 'This preview cannot sign you in yet. Connect an authentication backend to enable login.'
    );
  }

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      {isSignup && (
        <label className="field">
          <span>Full name</span>
          <input
            name="name"
            type="text"
            autoComplete="name"
            placeholder="Your name"
            required
          />
        </label>
      )}

      <label className="field">
        <span>Email address</span>
        <input
          name="email"
          type="email"
          autoComplete="email"
          placeholder="you@example.com"
          required
        />
      </label>

      <label className="field">
        <span>Password</span>
        <input
          name="password"
          type="password"
          autoComplete={isSignup ? 'new-password' : 'current-password'}
          placeholder="At least 8 characters"
          minLength="8"
          required
        />
      </label>

      {isSignup && (
        <>
          <label className="field">
            <span>Confirm password</span>
            <input
              name="confirmPassword"
              type="password"
              autoComplete="new-password"
              placeholder="Enter your password again"
              minLength="8"
              required
            />
          </label>

          <label className="terms-check">
            <input type="checkbox" required />
            <span>I agree to the community terms and privacy policy.</span>
          </label>
        </>
      )}

      {!isSignup && (
        <button
          className="forgot-link"
          type="button"
          onClick={() =>
            setMessage(
              'Password recovery is not available until an authentication backend is connected.'
            )
          }
        >
          Forgot password?
        </button>
      )}

      <button className="submit-button" type="submit">
        {isSignup ? 'Create your account' : 'Sign in'}
        <span aria-hidden="true">→</span>
      </button>

      {message && (
        <p className="form-message" role="status">
          {message}
        </p>
      )}
    </form>
  );
}

export default AuthForm;